// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9134290e","553":"1572c685","977":"c0150702"}[chunkId] + ".chunk.js";
};